import { render, staticRenderFns } from "./MenuCedar.vue?vue&type=template&id=6bd0ac62"
import script from "./MenuCedar.vue?vue&type=script&lang=js"
export * from "./MenuCedar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports